type HttpMethod = "GET" | "POST" | "PATCH" | "DELETE";

interface MethodBadgeProps {
  method: HttpMethod;
}

const METHOD_COLORS: Record<HttpMethod, string> = {
  GET: "bg-emerald-500/15 text-emerald-400 border-emerald-500/25",
  POST: "bg-blue-500/15 text-blue-400 border-blue-500/25",
  PATCH: "bg-amber-500/15 text-amber-400 border-amber-500/25",
  DELETE: "bg-red-500/15 text-red-400 border-red-500/25",
};

export function MethodBadge({ method }: MethodBadgeProps) {
  return (
    <span
      className={`inline-block px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider border ${METHOD_COLORS[method]}`}
    >
      {method}
    </span>
  );
}

interface StatusBadgeProps {
  code: number;
}

function getStatusColor(code: number): string {
  if (code >= 200 && code < 300)
    return "bg-emerald-500/15 text-emerald-400 border-emerald-500/25";
  if (code >= 400 && code < 500)
    return "bg-amber-500/15 text-amber-400 border-amber-500/25";
  if (code >= 500)
    return "bg-red-500/15 text-red-400 border-red-500/25";
  return "bg-base-300 text-base-content/60 border-base-content/10";
}

export function StatusBadge({ code }: StatusBadgeProps) {
  return (
    <span
      className={`inline-block px-2 py-0.5 rounded text-[10px] font-bold tracking-wider border ${getStatusColor(code)}`}
    >
      {code}
    </span>
  );
}
